import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationComissao } from './integration-comissao';
import { IntegrationPeriodicidade, periodicidadeDiaria, isPeriodicidadeDiaria, periodicidadeMensal, isPeriodicidadeMensal, periodicidadeAnual, isPeriodicidadeAnual, periodicidadeGeral, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationComissaoHttpService } from './services';

@Component({
    selector: 'sgt-integration-comissao-modal',
    templateUrl: './integration-comissao-modal.component.html',
    styleUrls: ['./integration-comissao-modal.component.less']
})
export class IntegrationComissaoModalComponent implements OnInit {
    entity = new IntegrationComissao();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeDiaria,
        periodicidadeMensal,
        periodicidadeAnual,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationComissaoHttpService: IntegrationComissaoHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationComissaoPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataInicialBase = null;
        }
    }

    /** Executa a integração de leitura das comissões com os sistemas ERP's */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando comissões com o ERP', 'Executando sincronização das comissões com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationComissaoHttpService.execReadIntegration(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização das comissões com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização das comissões com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização das comissões com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeDiaria(periodicidade)) {
            return 'Diária - Comissões lançadas nas últimas 24 horas';
        } else if (isPeriodicidadeMensal(periodicidade)) {
            return 'Mensal - Comissões lançadas a partir do mês anterior';
        } else if (isPeriodicidadeAnual(periodicidade)) {
            return 'Anual - Comissões lançadas a partir do ano anterior';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Comissões lançadas a partir de uma data específica'
        }
        return '';
    }
}
